import React from 'react';
import { Box, Text, Heading, Stack, Container, List, ListItem } from '@chakra-ui/react';
import privacyPolicyImage from '../../assets/privacypolicy.png'; // Adjust the path to your image

const PrivacyPolicy = () => {
  return (
    <Box
      backgroundImage={`url(${privacyPolicyImage})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      opacity="0.8" // Adjust the opacity to your liking
      css={{
        /* Hide scrollbar */
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&': {
          '-ms-overflow-style': 'none',  /* IE and Edge */
          'scrollbar-width': 'none',     /* Firefox */
        },
      }}
    >
      <Container maxW="100%" py={10} px={6} bg="rgba(255, 255, 255, 0.9)" borderRadius="md">
        <Stack spacing={6} textAlign="left" width="100%">
         

          {/* Last Updated Container */}
          <Box textAlign="left" p={4} borderWidth="1px" borderRadius="md" bg="gray.100" mb={6}>
          <Heading as="h1" size="lg" mb={6} fontWeight="extrabold">
            Curolyn Privacy Policy
          </Heading>
            <Text fontWeight="bold">Last Updated On: October 7, 2024</Text>
          </Box>

          <Text fontSize="md" color="gray.600" mb={6}>
            Welcome to Curolyn, a hiring and seeking platform focused on connecting medical professionals with temporary job opportunities. We value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and protect your data when you use our platform.
          </Text>


          <Box>
            <Heading as="h2" size="md" mb={4}>
              1. Information We Collect
            </Heading>
            <Text fontWeight="bold">Providers (Individuals or Organizations)</Text>
            <Text mb={4}>
              When you create an account to post jobs as a provider, we collect:
              <List spacing={2} ml={6}>
                <ListItem>– Full Name or Organization Name</ListItem>
                <ListItem>– Email Address</ListItem>
                <ListItem>– ID Cards or Licenses</ListItem>
                <ListItem>– Contact Information</ListItem>
              </List>
            </Text>

            <Text fontWeight="bold">Seekers (Individuals or Teams)</Text>
            <Text>
              When you create an account to apply for jobs as a seeker, we collect:
              <List spacing={2} ml={6}>
                <ListItem>– Full Name</ListItem>
                <ListItem>– Email Address</ListItem>
                <ListItem>– Certificates or Licenses</ListItem>
                <ListItem>– Contact Information</ListItem>
              </List>
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              2. How We Use Your Data
            </Heading>
            <Text>We use the data collected for the following purposes:</Text>
            <List spacing={2} ml={6}>
              <ListItem>– Job Matching: Allowing providers to post jobs and seekers to apply for them.</ListItem>
              <ListItem>– Account Management: Creating and managing your account on Curolyn.</ListItem>
              <ListItem>– Verification: Validating licenses, ID cards, and certificates to ensure compliance with medical industry standards.</ListItem>
              <ListItem>– Notifications: Sending job-related updates and communication regarding your account.</ListItem>
              <ListItem>– Platform Improvement: Enhancing the functionality and performance of Curolyn.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              3. Data Sharing
            </Heading>
            <Text>We only share your data with trusted third parties for the following purposes:</Text>
            <List spacing={2} ml={6}>
              <ListItem>– Licensing Validation: We may share your information with third-party services to validate your professional credentials.</ListItem>
              <ListItem>– Third-Party Service Providers: We use Google for sign-in and AWS and MongoDB for data storage and management. These services help us secure and store your information safely.</ListItem>
            </List>
            <Text>We do not sell or rent your personal data to any third party.</Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              4. Cookies and Tracking
            </Heading>
            <Text>We may use cookies and other tracking technologies to enhance your experience on our platform, improve functionality, and analyze usage patterns.</Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              5. Data Retention
            </Heading>
            <Text>We retain your data for as long as your account is active. Once you delete your account, all your data will be removed from our systems.</Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              6. Your Rights
            </Heading>
            <Text>As a user of Curolyn, you have the following rights regarding your data:</Text>
            <List spacing={2} ml={6}>
              <ListItem>– Access: You can request to view the data we have collected about you.</ListItem>

              <ListItem>– Update: You can update your account details and information at any time.</ListItem>
              <ListItem>– Delete: You can delete your account, and your data will be permanently erased from our systems.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              7. Data Security
            </Heading>
            <Text>We take your data security seriously and implement the following measures to protect it:</Text>
            <List spacing={2} ml={6}>
              <ListItem>– Encryption: Your data is encrypted both in transit and at rest.</ListItem>
              <ListItem>– Third-Party Services: We use secure cloud services such as AWS and MongoDB to store and process your information safely.</ListItem>
              <ListItem>– Regular Audits: We regularly audit our security protocols to ensure that your data is protected.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              8. Changes to the Privacy Policy
            </Heading>
            <Text>We may update this privacy policy to reflect changes to our practices. We will notify you of any significant changes by updating the date at the top of the policy and sending a notification via email or through the platform.</Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={4}>
              9. Contact Us
            </Heading>
            <Text>
              If you have any questions or concerns about our privacy policy or how we handle your data, please contact us at:
            </Text>
            <Text fontWeight="bold" mt={2}>Bostrix Inc.</Text>
            <Text>Email: support@Curolyn.com</Text>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
